import ResponseStructureBlock from './ResponseStructureBlock';
import { ResponseStructureBlockProps, ResponseStructureBlockValueProps } from './types';

export type { ResponseStructureBlockProps, ResponseStructureBlockValueProps };
export default ResponseStructureBlock;
